import type { CourseRecurrence } from '@prisma/client';
import { ClassFormat, CourseType } from '@prisma/client';
import { schoolOptions } from '../data/schools';
import type { ClassFormSchemaInput, ClassRecurrenceSchemaInput, ClassCommonSchemaInput, ClassFormatSchemaInput } from './class-form-schema';
export const DEFAULT_TIME_ZONE = 'Asia/Tokyo';
export const DEFAULT_STUDY_BUDDY_WEEK_HOURS_OFFSET = 12;
export const DEFAULT_MATERIAL_WEEK_IN_COURSE_DAYS_OFFSET = 2;
export const getClassInitialFormValues = ({
  courseRecurrence,
  courseType
}: {
  courseRecurrence: CourseRecurrence;
  courseType: CourseType;
}): ClassFormSchemaInput => {
  const commonDefaultValues: ClassCommonSchemaInput = {
    name: '',
    timeZone: DEFAULT_TIME_ZONE,
    classSize: '',
    maxClassSize: '',
    timeBlockName: '',
    bannerFileKey: '',
    timeBlockStart: 0,
    timeBlockEnd: 0,
    school: courseType === CourseType.KAPLUS ? schoolOptions[courseType][0].short : '',
    format: 'UNKNOWN',
    isMakeup: false
  };
  const recurrenceDefaultValues: ClassRecurrenceSchemaInput = {
    recurrence: courseRecurrence,
    startDate: '',
    endDate: '',
    occursOn: [],
    startWeekIndex: '',
    endWeekIndex: ''
  };
  const formatDefaultValues: ClassFormatSchemaInput = {
    format: courseType === CourseType.KAPLUS ? ClassFormat.ONLINE : 'UNKNOWN',
    room: '',
    hasPalette: false
  };
  return {
    ...commonDefaultValues,
    ...recurrenceDefaultValues,
    ...formatDefaultValues
  };
};